var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0B90B;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2082423948800"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.3,385.4L1250,0l666.7,385.4l-250,135.4L1250,281.2L822.9,520.8L583.3,385.4L583.3,385.4z M1906.2,864.6    l-239.6-135.4L1250,968.8L822.9,729.2L583.3,864.6v281.3l416.7,239.6l0,489.6l239.6,145.8l239.6-145.8v-479.2l416.7-239.6V864.6    L1906.2,864.6L1906.2,864.6z M1906.2,1635.4v-281.2L1666.7,1500v270.8L1906.2,1635.4L1906.2,1635.4z M2083.3,1729.2l-416.7,239.6    V2250l666.7-385.4v-770.8l-250,156.2V1729.2z M1843.8,625l239.6,145.8v281.3l239.6-145.8V625l-239.6-145.8L1843.8,625L1843.8,625z     M1000,2072.9v281.2l239.6,145.8l239.6-145.8v-281.2l-239.6,145.8L1000,2072.9L1000,2072.9z M583.3,1635.4l239.6,135.4v-281.2    l-239.6-145.8V1635.4L583.3,1635.4z M1000,625l239.6,145.8l250-145.8L1250,479.2L1000,625z M406.2,770.8l250-145.8l-250-145.8    L166.7,625v281.2l239.6,145.8V770.8z M406.2,1250l-239.6-145.8V1875l666.7,385.4v-281.2l-416.7-239.6l0-489.6H406.2L406.2,1250z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 2500,
    height: 2500
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/BNBLogo.5b904dce7acedd24bd5c7c9a2790d367.svg";
export { ForwardRef as ReactComponent };